import React from 'react';
import { OrderDetailsItemsSection } from './OrderDetailsItemsSection';
import { orderDetailsItemsSectionsConfig } from './orderDetailsItemsSectionsConfig';

export const OrderDetailsItemsSections: React.FC = () => (
  <>
    {orderDetailsItemsSectionsConfig.map(props => (
      <OrderDetailsItemsSection key={props.propertyName} {...props} />
    ))}
  </>
);
